import React, { useState } from 'react';
import './App.scss';
import 'styles/normalize.scss';
import 'styles/styles.scss';
import PublicRoutes from 'routes';
import { BrowserRouter } from 'react-router-dom';
import Menu from 'layout/Menu';
import Stars from 'layout/Background/Stars';
import animationContext from 'context/animation';
import Sidebar from 'layout/Sidebar';
import MENU_ITEMS from 'layout/Menu/constants/ConstMenuItems';

function App() {
  const [animation, setAnimation] = useState('next');
  const [currentPageIndex, setCurrentPageIndex] = useState(
    MENU_ITEMS.findIndex(item => item.link === window.location.pathname),
  );

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <animationContext.Provider value={{ animation, setAnimation, currentPageIndex, setCurrentPageIndex }}>
      <Stars />
      <BrowserRouter>
        <div className="h-[100dvh] w-full flex text-white items-center justify-center">
          <Sidebar />
          <Menu />
          <div className="flex w-full h-full text-center justify-center z-10 mx-4 sm:mx-8">
            <PublicRoutes />
          </div>
        </div>
      </BrowserRouter>
    </animationContext.Provider>
  );
}

export default App;
